import Vue from 'vue'
import Vuex from 'vuex'
import {
  getBanners,
  getServices,
  getPartners,
  getNewsList,
  getNewsReadCounts,
  getNewsReadCount,
  incrementNewsRead,
  getInsuranceList,
  getInsuranceReadCounts,
  getInsuranceReadCount,
  incrementInsuranceRead
} from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    bannersList: [],
    servicesList: [],
    partnersList: [],
    newsList: [],
    readCounts: {},
    insuranceList: [],
    insuranceReadCounts: {}
  },
  mutations: {
    setBannersList(state, list) {
      state.bannersList = Array.isArray(list) ? list : []
    },
    setServicesList(state, list) {
      state.servicesList = Array.isArray(list) ? list : []
    },
    setPartnersList(state, list) {
      state.partnersList = Array.isArray(list) ? list : []
    },
    setNewsList(state, list) {
      state.newsList = Array.isArray(list) ? list : []
    },
    setReadCount(state, { id, count }) {
      Vue.set(state.readCounts, String(id), count)
    },
    setReadCounts(state, counts) {
      if (counts && typeof counts === 'object') {
        state.readCounts = { ...counts }
      }
    },
    setInsuranceList(state, list) {
      state.insuranceList = Array.isArray(list) ? list : []
    },
    setInsuranceReadCount(state, { id, count }) {
      Vue.set(state.insuranceReadCounts, String(id), count)
    },
    setInsuranceReadCounts(state, counts) {
      if (counts && typeof counts === 'object') {
        state.insuranceReadCounts = { ...counts }
      }
    }
  },
  actions: {
    async fetchBanners({ commit }) {
      try {
        const { data } = await getBanners()
        commit('setBannersList', data)
      } catch (e) {
        commit('setBannersList', [])
      }
    },
    async fetchServices({ commit }) {
      try {
        const { data } = await getServices()
        commit('setServicesList', data)
      } catch (e) {
        commit('setServicesList', [])
      }
    },
    async fetchPartners({ commit }) {
      try {
        const { data } = await getPartners()
        commit('setPartnersList', data)
      } catch (e) {
        commit('setPartnersList', [])
      }
    },
    async fetchNews({ commit }) {
      try {
        const [listRes, countsRes] = await Promise.all([getNewsList(), getNewsReadCounts()])
        commit('setNewsList', listRes.data)
        commit('setReadCounts', countsRes.data)
      } catch (e) {
        commit('setNewsList', [])
      }
    },
    async fetchReadCount({ commit }, id) {
      try {
        const { data } = await getNewsReadCount(id)
        commit('setReadCount', { id: data.id, count: data.count })
      } catch (_) { /* ignore */ }
    },
    async incrementReadCount({ commit }, id) {
      try {
        const { data } = await incrementNewsRead(id)
        commit('setReadCount', { id: data.id, count: data.count })
      } catch (_) { /* ignore */ }
    },
    async fetchInsurance({ commit }) {
      try {
        const [listRes, countsRes] = await Promise.all([getInsuranceList(), getInsuranceReadCounts()])
        commit('setInsuranceList', listRes.data)
        commit('setInsuranceReadCounts', countsRes.data)
      } catch (e) {
        commit('setInsuranceList', [])
      }
    },
    async fetchInsuranceReadCount({ commit }, id) {
      try {
        const { data } = await getInsuranceReadCount(id)
        commit('setInsuranceReadCount', { id: data.id, count: data.count })
      } catch (_) { /* ignore */ }
    },
    async incrementInsuranceReadCount({ commit }, id) {
      try {
        const { data } = await incrementInsuranceRead(id)
        commit('setInsuranceReadCount', { id: data.id, count: data.count })
      } catch (_) { /* ignore */ }
    }
  },
  getters: {
    getBannersList: state => [...state.bannersList].reverse(),
    getBannerById: state => id => state.bannersList.find(b => b.id === Number(id)) || null,
    getServicesList: state => [...state.servicesList].reverse(),
    getServiceById: state => id => state.servicesList.find(s => s.id === Number(id)) || null,
    getPartnersList: state => [...state.partnersList].reverse(),
    getNewsList: state => [...state.newsList].reverse(),
    getNewsById: state => id => state.newsList.find(n => n.id === Number(id)) || null,
    getReadCount: state => id => Number(state.readCounts[String(id)]) || 0,
    getInsuranceList: state => [...state.insuranceList].reverse(),
    getInsuranceById: state => id => state.insuranceList.find(n => n.id === Number(id)) || null,
    getInsuranceReadCount: state => id => Number(state.insuranceReadCounts[String(id)]) || 0
  }
})
